export const JWT_TOKEN_EXPIRED = 'JWT_TOKEN_EXPIRED'
